import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyShortLink = lazy(() => import('./ShortLink'));

export const ShortLink: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyShortLink {...props} />
	</Suspense>
);
